import { Component, OnInit } from '@angular/core';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-gestao',
  templateUrl: './home-gestao.component.html',
  styleUrls: ['./home-gestao.component.scss']
})
export class HomeGestaoComponent implements OnInit {
  // Dados do Dashboard
  resumoCards = {
    totalClientes: 152,
    auditoriasAndamento: 89,
    auditoriasConcluidas: 45,
    novasSolicitacoes: 18
  };

  // Dados do Gráfico Principal
  desempenhoAuditorias = {
    total: 248,
    andamento: 89,
    concluidas: 45,
    percentuais: {
      sucesso: 40,
      andamento: 35,
      pendente: 25
    }
  };

  // Dados de Status
  statusAuditorias = [
    { status: 'Em Andamento', quantidade: 89, variacao: '+12%', tipo: 'success' },
    { status: 'Concluídas', quantidade: 45, variacao: '+5%', tipo: 'warning' },
    { status: 'Pendentes', quantidade: 18, variacao: '-2%', tipo: 'danger' }
  ];

  // Dados de Atividades Recentes
  ultimasAtividades = [
    {
      titulo: 'Nova Auditoria Iniciada',
      cliente: 'Hospital São Lucas',
      status: 'Novo',
      tipo: 'primary'
    },
    {
      titulo: 'Auditoria Concluída',
      cliente: 'Clínica Santa Maria',
      status: 'Concluído',
      tipo: 'success'
    },
    {
      titulo: 'Documentação Pendente',
      cliente: 'Hospital Central',
      status: 'Pendente',
      tipo: 'warning'
    }
  ];

  // Lista de meses para o seletor
  meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
           'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  mesSelecionado = 'Janeiro';

  // Dados do Gráfico de Pizza
  pieChartData: {
    concluidas: number;
    andamento: number;
    pendentes: number;
    graus: {
      concluidas: number;
      andamento: number;
      pendentes: number;
    }
  } = {
    concluidas: 0,
    andamento: 0,
    pendentes: 0,
    graus: {
      concluidas: 0,
      andamento: 0,
      pendentes: 0
    }
  };

  constructor(
    private ajax: AjaxService,
    public util: UtilService
  ) { }

  ngOnInit() {
    // Aqui você pode adicionar chamadas para APIs para carregar dados reais
    this.atualizarDadosGrafico();
  }

  // Método para atualizar dados quando o mês for alterado
  onMesChange(mes: string) {
    this.mesSelecionado = mes;
    // Aqui você pode adicionar lógica para atualizar os dados baseado no mês selecionado
    this.atualizarDadosGrafico();
  }

  private atualizarDadosGrafico() {
    // Calcula os percentuais baseados nos dados reais
    const total = this.desempenhoAuditorias.total;
    const concluidas = Math.round((this.desempenhoAuditorias.concluidas / total) * 100);
    const andamento = Math.round((this.desempenhoAuditorias.andamento / total) * 100);
    const pendentes = 100 - concluidas - andamento;

    // Atualiza os dados do gráfico com os graus corretos
    this.pieChartData = {
      concluidas,
      andamento,
      pendentes,
      graus: {
        concluidas: concluidas * 3.6,  // Converte percentual para graus (360/100 = 3.6)
        andamento: andamento * 3.6,
        pendentes: pendentes * 3.6
      }
    };
  }

  // Método para chamada AJAX do botão Teste
  public testeAjax() {
    this.util.showLoading();
    const url = API + 'RespostaFormulario/RespostaFormulario/exportarResultadoTriagem/55';
    this.ajax.get(url).subscribe(
      (resp) => {
        this.util.closeLoading();
        this.util.toasterShowSuccess('Sucesso', 'Chamada AJAX realizada com sucesso!');
        // Se for para baixar arquivo, pode usar window.open(url);
      },
      (err) => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao realizar chamada AJAX!');
      }
    );
  }
}
